export var VariantEnum;
(function (VariantEnum) {
    VariantEnum["TAGS"] = "tags";
    VariantEnum["TABS"] = "tabs";
})(VariantEnum || (VariantEnum = {}));
